import script from "./AccountRebate.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountRebate.vue?vue&type=script&setup=true&lang=ts"

import "./AccountRebate.vue?vue&type=style&index=0&id=537305de&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537305de"]])

export default __exports__